<cs-fab-button #activeCloseButton class="active-close-button" [icon]="icon"
  (click)="handleActiveCloseButtonClick($event)">
</cs-fab-button>
<div #fabList class="fab-list">
  <ng-content></ng-content>
</div>